import { render, staticRenderFns } from "./FeedbackRating.vue?vue&type=template&id=59a94740"
import script from "./FeedbackRating.vue?vue&type=script&lang=js"
export * from "./FeedbackRating.vue?vue&type=script&lang=js"
import style0 from "./FeedbackRating.vue?vue&type=style&index=0&id=59a94740&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports